export default "__VITE_ASSET__Cg5cR1iQ__"